"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountServiceModelSchema = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const data_1 = require("@citibot/data");
const twilio_service_model_1 = require("./twilio.service.model");
const keen_service_model_1 = require("./keen.service.model");
const notify_service_model_1 = require("./notify.service.model");
exports.AccountServiceModelSchema = yup_lib_1.default.object().shape({
    account: yup_lib_1.default.string().required(),
    service: yup_lib_1.default.mixed().oneOf(Object.values(data_1.AccountServiceType)).required(),
    additionalConfiguration: yup_lib_1.default.object().when(['service'], {
        is: (service) => {
            return service === data_1.AccountServiceType.twilio;
        },
        then: yup_lib_1.default.object().shape(twilio_service_model_1.TwilioAdditionalConfigSchemaObj).required(),
        otherwise: yup_lib_1.default.object().when(['service'], {
            is: (service) => service === data_1.AccountServiceType.keen,
            then: yup_lib_1.default.object().shape(keen_service_model_1.KeenAdditionalConfigSchemaObj).required(),
            otherwise: yup_lib_1.default.object().when(['service'], {
                is: (service) => service === data_1.AccountServiceType.notify,
                then: yup_lib_1.default.object().shape(notify_service_model_1.NotifyAdditionalConfigSchemaObj).required(),
                otherwise: yup_lib_1.default.object().notRequired()
            })
        })
    }),
    meta: yup_lib_1.default.object().notRequired()
});
